import { useState } from 'react';

const faqs = [
  {
    q: 'Fiyat neden değişiyor?',
    a: 'Fiyatlarımız; hizmet türüne, koltuk/yatak sayısına, kirlilik derecesine ve hizmet bölgesine göre değişmektedir. Örneğin, 3\'lü bir koltuk takımının fiyatı, 5\'li bir takımdan farklı olacaktır. Doğru fiyat almak için WhatsApp üzerinden veya telefon ile bize ulaşabilirsiniz.',
  },
  {
    q: 'Yerinde temizlik nasıl yapılır?',
    a: 'Ekibimiz belirlenen tarih ve saatte evinize gelir. Özel ekipman ve kimyasallarımızla mobilya, halı veya eşyalarınızı yerinde temizler. Büyük eşyaları taşımanıza gerek kalmaz. İşlem sonrası hızlı kuruma süreleri sayesinde gün içinde kullanmaya devam edebilirsiniz.',
  },
  {
    q: 'Kurumsal hizmet veriyor musunuz?',
    a: 'Evet! Otel, apart, site, okul ve ofis gibi kurumsal müşterilerimize toplu ve sözleşmeli hizmet sunuyoruz. Otel yatak yıkama, büyük alan halı temizliği ve inşaat sonrası temizlik gibi projelerde deneyimliyiz. Detaylı bilgi için bizimle iletişime geçin.',
  },
  {
    q: 'Hangi bölgelere hizmet veriyorsunuz?',
    a: 'İstanbul Anadolu Yakası, Yalova, Karamürsel, Kocaeli ve İzmit\'te hizmet vermekteyiz. Bölgeniz için müsaitlik durumunu öğrenmek amacıyla bize ulaşabilirsiniz.',
  },
  {
    q: 'Kullandığınız kimyasallar çocuklar ve evcil hayvanlar için güvenli mi?',
    a: 'Evet, kullandığımız tüm temizlik ürünleri sertifikalı ve insan sağlığına uygun ürünlerdir. Çocukların ve evcil hayvanların bulunduğu ortamlarda güvenle kullanılabilen formüller tercih ediyoruz.',
  },
  {
    q: 'Randevu nasıl alınır?',
    a: 'Hemen Randevu Al butonuna tıklayarak formu doldurabilir, WhatsApp\'tan mesaj gönderebilir veya telefon numaralarımızı arayabilirsiniz. Size en kısa sürede dönüş yaparız.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section id="sss" className="py-20 md:py-28 bg-slate-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-block bg-sky-100 text-sky-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
            Sıkça Sorulan Sorular
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-4">Aklınızdakileri Cevaplayalım</h2>
          <p className="text-slate-500 text-lg">Hizmetlerimiz hakkında en çok merak edilenleri derledik.</p>
        </div>

        {/* Accordion */}
        <div className="flex flex-col gap-3">
          {faqs.map((faq, i) => (
            <div
              key={faq.q}
              className={`bg-white rounded-2xl border transition-all duration-200 overflow-hidden ${openIndex === i ? 'border-sky-400 shadow-sm' : 'border-slate-100 hover:border-sky-200'}`}
            >
              <button
                onClick={() => toggle(i)}
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
              >
                <span className={`font-semibold text-base md:text-lg transition-colors ${openIndex === i ? 'text-sky-700' : 'text-slate-900'}`}>
                  {faq.q}
                </span>
                <span className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-200 ${openIndex === i ? 'bg-sky-600 text-white rotate-45' : 'bg-slate-100 text-slate-500'}`}>
                  <i className="ri-add-line text-lg" />
                </span>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5 text-slate-600 text-sm md:text-base leading-relaxed border-t border-slate-100 pt-4">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA Below FAQ */}
        <div className="mt-10 text-center">
          <p className="text-slate-500 mb-4">Sorunuz burada yok mu?</p>
          <a
            href="https://wa.me/905055600419?text=Merhaba%2C%20temizlik%20hizmeti%20hakk%C4%B1nda%20sorum%20var."
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white font-bold px-7 py-3.5 rounded-full transition-all whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-lg" />
            WhatsApp&apos;tan Sorun
          </a>
        </div>
      </div>
    </section>
  );
}
